
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import BaseLayout from "@components/BaseLayout";
import TranslatedHtml from "@components/common/TranslatedHtml";
import { Routes } from "@services/routes";
import { BASE_URL } from "config";
/**
 * This page shows the terms of use
 *
 * for costumization especially the following elements must be replaced
 *
 * For customization of the content change /locales/custom-locales/de/terms-of-use.json
 */
const TermsOfUsePage: React.FC = () => {
    const { t } = useTranslation();
    // sections of the translation file
    // for customization: delete or add entries
    const termsOfUseSections: string[] = [
        "scope",
        "rightOfUsage",
        "registration",
        "scopeOfService",
        "safetyRequirements",
        "usageOfData",
        "userResponsability",
        "advertising",
        "rightOfDataUse",
        "liability",
        "dataProtectionAndCopyright",
        // Achtung: endOfUsage verweist auf andere Punkte in den Nutzungsbedingungen, die sich ändern könnten, ist aber (noch nicht) in den Params drin
        "endOfUsage",
        "changeOfTermsOfUse",
        "rightOfRecourse",
        "finalClause"
    ];
    // used params in text
    // adopt values for customization
    const params: Record<string, string> = {
        // common params
        baseUrl: BASE_URL,
        netiquette: Routes.Netiquette,
        contact: Routes.Contact,
        dataProtection: Routes.DataProtection,
        // specific params, part of the translation file
        platformOperator: t("terms-of-use:customization.platformOperator"),
        platformName: t("terms-of-use:customization.platformName"),
        platformNameShort: t("terms-of-use:customization.platformNameShort"),
        communityManagement: t("terms-of-use:customization.communityManagement"),
        technicalSupport: t("terms-of-use:customization.technicalSupport"),
        makeRepresentationVisibleFor: t("terms-of-use:customization.makeRepresentationVisibleFor"),
        platformTopic: t("terms-of-use:customization.platformTopic"),
        possibleDamagedInstitutions: t("terms-of-use:customization.possibleDamagedInstitutions"),
        actorsAtDamage: t("terms-of-use:customization.actorsAtDamage"),
        placeOfJuristdiction: t("terms-of-use:customization.placeOfJuristdiction"),
        operatingDeadline: t("terms-of-use:customization.operatingDeadline"),
    };
    return <BaseLayout pageTitle={t("terms-of-use:title", params)}>
    <Card>
      <CardHeader>
        <h1>{t("terms-of-use:title", params)}</h1>
      </CardHeader>
      <CardBody className="title-counter">
        <Row>
          <Col className="text-justify">
            {termsOfUseSections.map(section => {
            return <div key={section}>
                <h1 className="h3">{t("terms-of-use:" + section + ".title", params)}</h1>
                <TranslatedHtml content={"terms-of-use:" + section + ".content"} params={params}/>
              </div>;
        })}
          </Col>
        </Row>
      </CardBody>
    </Card>
  </BaseLayout>;
};
export default TermsOfUsePage;

    async function __Next_Translate__getStaticProps__18c4f51718b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/terms-of-use',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c4f51718b__ as getStaticProps }
  